import React from "react";
import AbstractButton from "../components/AbstractButton";
import { ReactComponent as CancelIcon } from "../../assets/icons/backspace-20-regular.svg?react";
import { ReactComponent as LeaveIcon } from "../../assets/icons/forward-chevrons.svg?react";
import ForegroundColorSet from "../../utilities/enums/ForegroundColorSet";
import BackgroundColorSet from "../../utilities/enums/BackgroundColorSet";

const StockUnsavedChanges = (props: {
  showUnsavedChanges: boolean;
  onNavigate(): void;
  onCancel(): void;
}) => {
  const handleStayPress = () => {
    props.onCancel();
  };

  const handleLeavePress = () => {
    props.onNavigate();
  };

  return (
    <>
      <div
        className={
          "finish-page " +
          (props.showUnsavedChanges ? "modal-open" : "modal-closed")
        }
      >
        <div
          id="main-menu-modal-mask"
          onClick={props.onCancel}
          className="modal-mask"
        ></div>
        <div id="unsaved-changes-box" className="modal-page finish-page">
          <p id="finish-page-title">Exit Without Saving Changes</p>
          <div className="info-page-section">
            You have unsaved changes to parts you have counted, are you sure you
            want to leave?
          </div>
          <div className="modal-button-span">
            <AbstractButton
              id="stock-unsaved-stay-button"
              text="Stay"
              icon={<CancelIcon width="100%" height="100%" />}
              disabled={false}
              activeColor={ForegroundColorSet.Blue}
              background={BackgroundColorSet.Black1}
              specialClass={null}
              actionCallback={handleStayPress}
            />
            <AbstractButton
              id="stock-unsaved-leave-button"
              text="Leave"
              icon={<LeaveIcon width="100%" height="100%" />}
              disabled={false}
              activeColor={ForegroundColorSet.Red}
              background={BackgroundColorSet.Black1}
              specialClass={null}
              actionCallback={handleLeavePress}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default StockUnsavedChanges;
